import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Display = _ref => {
  let {
    afterLabelContent = null,
    disabled,
    id,
    label,
    onEditClick,
    value,
    hideLabel = false,
    preValueText = ''
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "w-full pr-2.5",
      children: [/*#__PURE__*/_jsx("h5", {
        className: hideLabel ? 'sr-only' : 'capitalize text-sm font-heavy-font tracking-normal leading-4',
        children: label
      }), /*#__PURE__*/_jsx("div", {
        children: afterLabelContent
      }), /*#__PURE__*/_jsxs("span", {
        className: "text-sm text-brand-blue",
        children: [preValueText, value]
      })]
    }), !disabled && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "Edit",
        onClick: onEditClick,
        id: "".concat(id, "-edit-btn"),
        color: "#4467AB",
        ariaLabel: "Edit",
        size: 18
      })
    })]
  });
};
Display.propTypes = {
  afterLabelContent: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.any.isRequired,
  onEditClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  preValueText: PropTypes.node
};
export default Display;
//# sourceMappingURL=Display.js.map